import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { invoiceBatchFilterSchema } from './invoice-batch-filter-schema';
import { invoiceBatchFilterDefaultValues } from './invoice-batch-model';

export function useInvoiceBatchFilterFormDefinition() {
  return useForm({
    resolver: zodResolver(invoiceBatchFilterSchema),
    defaultValues: invoiceBatchFilterDefaultValues,
  });
}
